'use client'
import { useGetUserByItineraryQuery } from '@/src/api/rtkQuery/itineraryApi'
import { selectAuth } from '@/src/redux/slices/authSlice'
import { useAppSelector } from '@/src/redux/store'
import useGetItineraryId from '../useGetItineraryId'

export const useGetSaveTravelerData = () => {
    const { signedIn } = useAppSelector(selectAuth)

    const itineraryId = useGetItineraryId()
    const {
        data: userData,
        isLoading: isUserLoading,
        error: userError
    } = useGetUserByItineraryQuery(
        {
            itineraryId
        },
        {
            skip: !signedIn || !itineraryId
        }
    )

    return { userData, isUserLoading, userError }
}
